import { QuestionRenderCondition } from '@ketch-com/windlass/dist/assessments/assessments'
import { useMemo, useState } from 'react'
import { createCustomContext } from 'utils/hooks/createCustomContext'

interface ConditionDetails extends QuestionRenderCondition {
  conditionMet: boolean
}

export type ConditionMap = Record<string, ConditionDetails>

export interface AssessmentConditionalRenderContextValue {
  setRenderConditionsMap: React.Dispatch<React.SetStateAction<ConditionMap>>
  renderConditionsMap: ConditionMap
}

const { Provider, useCustomContext: useAssessmentConditionalRenderContext } =
  createCustomContext<AssessmentConditionalRenderContextValue>({
    displayName: 'AssessmentConditionalRenderContext',
  })

export const AssessmentConditionalRenderContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [renderConditionsMap, setRenderConditionsMap] = useState<ConditionMap>({})

  const value = useMemo(
    () => ({
      renderConditionsMap,
      setRenderConditionsMap,
    }),
    [renderConditionsMap],
  )

  return <Provider value={value}>{children}</Provider>
}

export { useAssessmentConditionalRenderContext }
